import { useQuery } from "react-query";
import ApiResult from "utils/api/models/api-result";
import { ApiError } from "utils/api/models/api-error";
import { FetchSystemTerms } from "services/systemTerms";
import { SystemTermsModel } from "models/systemTerms";

export default function useSystemTerms() {
  const queryKey = ["system-terms"];
  return {
    ...useQuery<ApiResult<SystemTermsModel[]>, ApiError>(
      queryKey,
      () => FetchSystemTerms(),
      {
        staleTime: 10000,
        // enabled: hasPermission(["browse_companies"]),
      }
    ),
  };
}
